import { calendarDaysUntil, todayInTimezone } from '@resida/shared';

// Re-exports from @resida/shared — use these for all new code
export { formatCalendarDate, formatTimestamp, deriveTimezone } from '@resida/shared';

/**
 * Format a YYYY-MM-DD calendar date string for display.
 *
 * @deprecated Use formatCalendarDate(dateStr, timezone) from @resida/shared instead.
 * This function uses browser-local time (T12:00:00 noon hack) which does not
 * account for the property's timezone.
 */
export function formatLocalDate(
  dateStr: string | null | undefined,
  options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'short', day: 'numeric' },
): string {
  if (!dateStr) return '—';
  return new Date(dateStr + 'T12:00:00').toLocaleDateString('en-US', options);
}

/**
 * Format a full ISO timestamp string (e.g. createdAt, processedAt) for display.
 * These already carry timezone info so no adjustment is needed.
 *
 * @deprecated Use formatTimestamp(isoStr, timezone) from @resida/shared instead.
 * This function uses browser-local time rather than property timezone.
 */
export function formatDateTime(
  isoStr: string | null | undefined,
  options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' },
): string {
  if (!isoStr) return '—';
  return new Date(isoStr).toLocaleString('en-US', options);
}

/**
 * Whole calendar days a date-only `overdueSince` (UTC-midnight ISO string) is past, as of today in
 * the viewer's browser zone; never negative. Calendar-day math, not elapsed time (see
 * `calendarDaysUntil`).
 */
export function daysOverdue(overdueSinceIso: string): number {
  const localTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return Math.max(0, -calendarDaysUntil(overdueSinceIso, todayInTimezone(localTz)));
}
